<template>
  <div style="display: flex;">
    <button
      v-if="connectionStatus === 'unconnected' || connectionStatus === 'nonexistent'"
      @click="sendConnectRequest"
      class="connectButton"
    >
      {{ sendingConnectRequest ? "Sending request..." : "Connect" }}
    </button>
     <button
      v-if="connectionStatus === 'unconnected' || connectionStatus === 'nonexistent'"
      class="connectButton"
      @click="toggleDropdown"
    >
      <span>More</span>
      <span class="arrow">
        <IconBase
          icon-name="profile"
          iconColor="#2b2c2d"
          viewBox="0 0 451.847 451.847"
          width="100%"
          height="100%"
          strokeWidth="0px"
          ><IconArrowBottom
        /></IconBase>
      </span>
      <BlockExcludeDropdown v-if="dropdownOpen" :isExcluded="isExcluded" @exclude="exclude" @block="block"  @unexclude="unexclude" />
    </button>
    <button
      v-else-if="connectionStatus === 'pending'"
      class="connectButton"
      style="background-color: #f1f1f1"
    >
      Connect request pending
    </button>
    <button
      v-else-if="connectionStatus === 'connected'"
      class="connectButton"
      @click="toggleDropdown"
    >
      <span>Connected</span>
      <span class="arrow">
        <IconBase
          icon-name="profile"
          iconColor="#2b2c2d"
          viewBox="0 0 451.847 451.847"
          width="100%"
          height="100%"
          strokeWidth="0px"
          ><IconArrowBottom
        /></IconBase>
      </span>
      <ConnectDropdown v-if="dropdownOpen" :isExcluded="isExcluded" @unconnectUser="unconnectUser" @exclude="exclude" @block="block" @unexclude="unexclude" />
    </button>
    <button
      v-if="connectionStatus === 'pending' && currentUserSentRequest"
      @click="cancelConnectRequest"
      class="cancelButton"
    >
      {{ cancelingConnectRequest ? "Canceling..." : "Cancel request" }}
    </button>
  </div>
</template>

<script>
import IconBase from "../../../components/IconBase";
import IconArrowBottom from "../../../components/SVG/IconArrowBottom";
import ConnectDropdown from "./ConnectDropdown";

import BlockExcludeDropdown from "./BlockExcludeDropdown.vue";

import profileAPIService from "../../../api/profileAPIService";

import CloseComponent from "@/mixins/CloseComponent";

export default {
  name: "ConnectButton",
  mixins: [CloseComponent],

  components: {
    IconBase,
    IconArrowBottom,
    ConnectDropdown,
    BlockExcludeDropdown,
  },
  props: {
    profileOwnerID: {
      type: String,
      required: true
    },
    userID: {
      type: String,
      required: true
    },
    connectionStatus: {
      type: String,
      default: "nonexistent",
    },
    connectionID: String,
    currentUserSentRequest: Boolean,
    isExcluded: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      sendingConnectRequest: false,
      cancelingConnectRequest: false,
    };
  },
  computed: {
    dropdownOpen() {
      return this.componentOpen; /* from mixin */
    }
  },
  methods: {
    async sendConnectRequest() {
      this.sendingConnectRequest = true;
      if (this.profileOwnerID !== this.userID) {
        const result = await profileAPIService.sendConnectRequest(this.userID, this.profileOwnerID);
        if (result !== null) {
          console.log("NOICE", result);
          result.action = "connect";
          this.$emit("updateConnectionStatus", result);
        } else {
          console.log("RIP");
          console.error("@sendConnectRequest failed");
        }
      }
      this.sendingConnectRequest = false;
    },

    async cancelConnectRequest() {
      this.cancelingConnectRequest = true;
      if (this.profileOwnerID !== this.userID && this.connectionID) {
        const result = await profileAPIService.cancelConnectRequest(this.connectionID, this.userID, this.profileOwnerID);
        if (result !== null) {
          console.log("NOICE");
          result.action = "cancel";
          this.$emit("updateConnectionStatus", result);
        } else {
          console.log("RIP");
          console.error("@cancelConnectRequest failed");
        }
      }
      this.cancelingConnectRequest = false;
    },

    async unconnectUser() {
      if (this.profileOwnerID !== this.userID && this.connectionID && this.connectionStatus === 'connected') {
        const result = await profileAPIService.unconnect(this.connectionID, this.userID);
        if (result !== null) {
          console.log("NOICE: ", result);
          result.action = "unconnect";
          this.$emit("updateConnectionStatus", result);
        } else {
          console.error("@unconnect");
        }
      }
    },

    async exclude() {
      this.$store.dispatch("modals/setModalState", {
        modal: "excluding",
        newState: true,
      });
    },

    async block() {
      this.$store.dispatch("modals/setModalState", {
        modal: "blocking",
        newState: true,
      });
    },

    async unexclude() {
      await profileAPIService.unexcludeUser(this.userID, this.profileOwnerID);
      this.$store.dispatch("modals/setModalState", {
        modal: "unexcludingComplete",
        newState: true,
      });
      this.$emit('unexcludingComplete');
    },

    toggleDropdown() {
      /* wrapper for mixin */
      this.toggleComponent();
    },
  },
};
</script>